import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-chanpinku",
  "use": "icon-chanpinku-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-chanpinku\"><path d=\"M837.8 84.4H186.2L64 267.6v590.5c0 45 36.5 81.5 81.5 81.5h733.1c45 0 81.5-36.5 81.5-81.5V267.6L837.8 84.4z m-610.9 61.1h570.2l81.5 122.2H145.5l81.4-122.2z m366.6 183.2v285.1l-82.3-40.7-80.6 40.7V328.7h162.9z m305.4 509.1c0 22.5-18.2 40.7-40.7 40.7H165.8c-22.5 0-40.7-18.2-40.7-40.7V328.7h244.4v386.9l142.2-81.5 142.9 81.5V328.7H899v509.1z\" fill=\"#2c2c2c\" p-id=\"956\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/chanpinku.svg
// module id = JFoz
// module chunks = 60